import { tss } from '@/shared/styles/tss'

export const useStyles = tss.withName('Discount').create(({ theme }) => ({
  root: {
    display: 'flex',
    padding: '6px 8px',
    background: theme.colors.text.primary,
    justifyContent: 'center',
    borderRadius: theme.sizes.radiuses.xl,
    alignItems: 'center',

    gap: '2px',

    span: {
      color: 'black',
      textAlign: 'center',
      fontFamily: 'Space Grotesk',
      fontSize: '11px',
      fontWeight: '560',
      lineHeight: '12px',
      letterSpacing: '0.11px',
      textTransform: 'uppercase',
    },
  },
}))
